import { getPageLinksQuery, getPagePreviewLinkQuery } from '@redlink/services';

export const freshCache =
  ({ pageName }) =>
  (cache, { data }) => {
    freshLinks({ cache, data: data.BatchNewExternalLinks });
    freshPreviewLinks({ cache, data: data.BatchNewExternalLinks, pageName });
  };

const freshPreviewLinks = ({ cache, data, pageName }) => {
  try {
    let { LinksPreview: oldData } = cache.readQuery({
      query: getPagePreviewLinkQuery,
      variables: { pageName },
    });

    cache.writeQuery({
      query: getPagePreviewLinkQuery,
      data: {
        LinksPreview: [...oldData, ...data],
      },
      variables: { pageName },
    });
  } catch (e) {}
};

const freshLinks = ({ cache, data }) => {
  let { Links: oldData } = cache.readQuery({
    query: getPageLinksQuery,
  });

  cache.writeQuery({
    query: getPageLinksQuery,
    data: {
      Links: [...oldData, ...data],
    },
  });
};
